import React, { useState } from "react";
import {observer} from "mobx-react";
import {StringFieldEditorComponent} from "../string-field/string-field-editor.component";
import {IFormField} from "../../../models/forms/form-field.interface";
import {NullableString} from "../../../types/nullable-types";
import styled from "styled-components";
import {ZIndex} from "../../../types/z-index";
import {FieldEditorCommonProps} from "../inputs-common.props";
import {IonIcon} from "@ionic/react";
import {eyeOffOutline, eyeOutline} from "ionicons/icons";
import {useServices} from "../../../hooks/use-services.hook";

const EyeSlashBox = styled.span<{$hasError: boolean}>`
    display: flex;
    justify-content: center;
    align-items: center;
    //z-index: ${ZIndex.PasswordFieldIcon};
    cursor: pointer;
    font-size: 1.25rem;
`


interface PasswordFieldEditorComponentProps extends FieldEditorCommonProps{
    field: IFormField<NullableString>;
}

export const PasswordFieldEditorComponent: React.FC<PasswordFieldEditorComponentProps> = observer((props) => {
    const services = useServices();
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const {field, ...otherProps} = props;

    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };

    const renderIcon = () => {
        if(isPasswordVisible) {
            return (<IonIcon icon={eyeOutline}/>)
        } else {
            return (<IonIcon icon={eyeOffOutline}/>)
        }
    }

    let label: string;
    if(isPasswordVisible) {
        label = services.language.translate("Hide password");
    } else {
        label = services.language.translate("Show password");
    }

    const icon = (

        <EyeSlashBox $hasError={props.field.hasError} onClick={togglePasswordVisibility} title={label}>
            {renderIcon()}
        </EyeSlashBox>
    );

    return (
        <StringFieldEditorComponent field={field} type={isPasswordVisible ? "text" : "password"} iconRight={icon} {...otherProps}/>
    );
});
